import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { PositiveButtonStyled } from './styles/PositiveButtonStyled'

export const PositiveButton: FC<IBaseButtonProps> = PositiveButtonStyled

PositiveButton.displayName = 'PositiveButton'
